/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-hero-item.get-names.ts 
*/
:host {
  box-sizing: border-box;
  display: block;
  width: 100%;
}
:host * {
  box-sizing: border-box;
}

.ace-hero-item {
  background-color: var(--ace-color-surface-solid--100);
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;
}
.ace-hero-item__container {
  max-width: 1600px;
  position: relative;
  width: 100%;
  z-index: 2;
}
.ace-hero-item__container--basic {
  align-items: flex-start;
  display: flex;
  gap: var(--ace-primitive-spacing-normal);
  margin: var(--ace-primitive-spacing-x-loose) var(--ace-semantic-foundation-spacing-gutter-mobile-outer) var(--ace-primitive-spacing-normal);
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__container--basic {
    margin: var(--ace-primitive-spacing-xx-loose) var(--ace-semantic-foundation-spacing-gutter-tablet-outer) var(--ace-primitive-spacing-loose);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__container--basic {
    margin: var(--ace-primitive-spacing-xxx-loose) var(--ace-semantic-foundation-spacing-gutter-desktop-outer) var(--ace-primitive-spacing-x-loose);
  }
}
.ace-hero-item__container--game {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  justify-content: space-between;
  margin: var(--ace-semantic-foundation-spacing-gutter-mobile-outer);
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__container--game {
    gap: var(--ace-primitive-spacing-loose);
    margin: var(--ace-primitive-spacing-loose);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__container--game {
    flex-direction: row;
    gap: var(--ace-primitive-spacing-x-loose);
    margin: var(--ace-primitive-spacing-x-loose);
  }
}
.ace-hero-item__container--full-background {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  justify-content: flex-end;
  margin: var(--ace-semantic-foundation-spacing-gutter-mobile-outer);
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__container--full-background {
    gap: var(--ace-primitive-spacing-loose);
    margin: var(--ace-primitive-spacing-loose);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__container--full-background {
    gap: var(--ace-primitive-spacing-x-loose);
    margin: var(--ace-primitive-spacing-x-loose);
  }
}
.ace-hero-item__container--encapsulated {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0;
  justify-content: center;
  padding: 0;
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__container--encapsulated {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
}
.ace-hero-item__container--general {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__container--general {
    flex-direction: row;
  }
}
.ace-hero-item__content {
  position: relative;
  width: 100%;
  z-index: 2;
}
.ace-hero-item__content__text-block {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}
.ace-hero-item__content__text-block__headline-desc-block {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content__text-block__headline-desc-block {
    gap: var(--ace-primitive-spacing-normal);
  }
}
.ace-hero-item__content__text-block__headline-desc-block ::slotted(*) {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.ace-hero-item__content--basic__tags-block {
  padding-top: 0;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--basic__tags-block {
    padding-top: var(--ace-primitive-spacing-x-tight);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--basic__tags-block {
    padding-top: var(--ace-primitive-spacing-normal);
  }
}
.ace-hero-item__content--game__tags-block {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-hero-item__content--game__tags-block ::slotted(div) {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-hero-item__content--game__left-flex-container {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  justify-content: space-between;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--game__left-flex-container {
    align-items: center;
    flex-direction: row;
    gap: var(--ace-primitive-spacing-loose);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--game__left-flex-container {
    align-items: flex-end;
    gap: var(--ace-primitive-spacing-x-loose);
  }
}
.ace-hero-item__content--game__visual-block {
  max-width: unset;
  order: 2;
  position: relative;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--game__visual-block {
    max-height: 10rem;
    max-width: 17.5rem;
    order: 1;
  }
}
.ace-hero-item__content--game__headline {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  order: 1;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--game__headline {
    order: 2;
  }
}
.ace-hero-item__content--game__cta-block {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--game__cta-block {
    gap: var(--ace-primitive-spacing-normal);
  }
}
.ace-hero-item__content--game__cta-block ::slotted(div) {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--game__cta-block ::slotted(div) {
    gap: var(--ace-primitive-spacing-normal);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--game__cta-block {
    width: fit-content;
  }
}
.ace-hero-item__content--full-background__tags-block {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-hero-item__content--full-background__tags-block ::slotted(div) {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-hero-item__content--full-background__cta-controls-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  justify-content: space-between;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--full-background__cta-controls-wrapper {
    gap: var(--ace-primitive-spacing-loose);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--full-background__cta-controls-wrapper {
    align-items: center;
    flex-direction: row;
  }
}
.ace-hero-item__content--full-background__cta-block {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--full-background__cta-block {
    gap: var(--ace-primitive-spacing-normal);
  }
}
.ace-hero-item__content--full-background__cta-block ::slotted(div) {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--full-background__cta-block ::slotted(div) {
    gap: var(--ace-primitive-spacing-normal);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--full-background__cta-block {
    width: fit-content;
  }
}
.ace-hero-item__content--full-background__controls-block {
  display: flex;
  gap: var(--ace-primitive-spacing-normal);
  justify-content: space-between;
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--full-background__controls-block {
    justify-content: flex-start;
  }
}
.ace-hero-item__content--encapsulated__tags-block {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-hero-item__content--encapsulated__tags-block ::slotted(div) {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-hero-item__content--encapsulated__content-flex-container {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  padding: var(--ace-primitive-spacing-normal) var(--ace-primitive-spacing-normal) 0 var(--ace-primitive-spacing-normal);
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__content-flex-container {
    gap: var(--ace-primitive-spacing-loose);
    padding: 0;
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--encapsulated__content-flex-container {
    gap: var(--ace-primitive-spacing-x-loose);
  }
}
.ace-hero-item__content--encapsulated__box-block {
  background-color: var(--ace-color-surface-solid--100);
  border-radius: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  height: 100%;
  margin: 0;
  order: 2;
  padding: 0;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__box-block {
    border-radius: var(--ace-primitive-radius-medium);
    gap: var(--ace-primitive-spacing-loose);
    margin: 0 var(--ace-primitive-spacing-loose) var(--ace-primitive-spacing-loose) var(--ace-primitive-spacing-loose);
    padding: var(--ace-primitive-spacing-loose);
    width: calc(100% - 2 * var(--ace-primitive-spacing-loose));
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--encapsulated__box-block {
    border-radius: var(--ace-primitive-radius-large);
    gap: var(--ace-primitive-spacing-x-loose);
    height: fit-content;
    margin: var(--ace-primitive-spacing-x-loose) 0 var(--ace-primitive-spacing-x-loose) var(--ace-primitive-spacing-x-loose);
    order: 1;
    padding: var(--ace-primitive-spacing-x-loose);
    width: 50%;
  }
}
@media only screen and (min-width: calc(1600px + 4rem)) {
  .ace-hero-item__content--encapsulated__box-block {
    margin: var(--ace-primitive-spacing-x-loose) 0 var(--ace-primitive-spacing-x-loose);
  }
}
.ace-hero-item__content--encapsulated__cta-controls-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  justify-content: space-between;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__cta-controls-wrapper {
    gap: var(--ace-primitive-spacing-loose);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--encapsulated__cta-controls-wrapper {
    flex-direction: row;
  }
}
.ace-hero-item__content--encapsulated__cta-block {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
  backdrop-filter: blur(0.25rem);
  -webkit-backdrop-filter: blur(0.25rem);
  background-color: rgba(255, 255, 255, 0.01);
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  border-top: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  bottom: 0;
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  padding: var(--ace-primitive-spacing-normal);
  position: sticky;
  width: 100%;
  z-index: 2;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__cta-block {
    gap: var(--ace-primitive-spacing-normal);
  }
}
.ace-hero-item__content--encapsulated__cta-block ::slotted(div) {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__cta-block ::slotted(div) {
    gap: var(--ace-primitive-spacing-normal);
  }
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__cta-block {
    backdrop-filter: unset;
    -webkit-backdrop-filter: unset;
    background-color: unset;
    border: 0;
    gap: var(--ace-primitive-spacing-normal);
    padding: 0;
    position: unset;
    width: unset;
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--encapsulated__cta-block {
    width: fit-content;
  }
}
.ace-hero-item__content--encapsulated__controls-block {
  display: none;
  z-index: 2;
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--encapsulated__controls-block {
    display: flex;
    gap: var(--ace-primitive-spacing-normal);
    justify-content: flex-start;
    margin-top: 0;
    position: unset;
  }
}
.ace-hero-item__content--encapsulated__controls-block--mobile {
  display: flex;
  justify-content: space-between;
  padding: 0 var(--ace-primitive-spacing-normal);
  position: absolute;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__controls-block--mobile {
    padding: 0 var(--ace-primitive-spacing-loose);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--encapsulated__controls-block--mobile {
    display: none;
  }
}
.ace-hero-item__content--encapsulated__visual-block {
  align-items: center;
  display: flex;
  height: auto;
  justify-content: center;
  order: 1;
  position: relative;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__visual-block {
    width: calc(100% - 2 * var(--ace-primitive-spacing-loose));
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--encapsulated__visual-block {
    order: 2;
    width: 50%;
  }
}
.ace-hero-item__content--encapsulated__info-block {
  padding: 0 var(--ace-primitive-spacing-normal);
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--encapsulated__info-block {
    padding: 0;
  }
}
.ace-hero-item__content--general__tags-block {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-hero-item__content--general__tags-block ::slotted(div) {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
}
.ace-hero-item__content--general__content-flex-container {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  padding: var(--ace-primitive-spacing-normal) var(--ace-primitive-spacing-normal) 0 var(--ace-primitive-spacing-normal);
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--general__content-flex-container {
    gap: var(--ace-primitive-spacing-loose);
    padding: 0;
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--general__content-flex-container {
    gap: var(--ace-primitive-spacing-x-loose);
  }
}
.ace-hero-item__content--general__box-container {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  height: 100%;
  justify-content: space-between;
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--general__box-container {
    height: unset;
  }
}
.ace-hero-item__content--general__box-block {
  background-color: var(--ace-color-surface-solid--100);
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  height: 100%;
  order: 2;
  padding: 0;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--general__box-block {
    gap: var(--ace-primitive-spacing-loose);
    padding: var(--ace-primitive-spacing-loose);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--general__box-block {
    justify-content: space-between;
    order: 1;
    padding: var(--ace-primitive-spacing-x-loose);
    width: 36%;
  }
}
@media only screen and (min-width: calc(1600px + 4rem)) {
  .ace-hero-item__content--general__box-block {
    padding: var(--ace-primitive-spacing-x-loose) var(--ace-primitive-spacing-x-loose) var(--ace-primitive-spacing-x-loose) 0;
  }
}
.ace-hero-item__content--general__info-block {
  padding: 0 var(--ace-primitive-spacing-normal);
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--general__info-block {
    padding: var(--ace-primitive-spacing-normal) 0;
  }
}
.ace-hero-item__content--general__cta-block {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
  backdrop-filter: blur(0.25rem);
  -webkit-backdrop-filter: blur(0.25rem);
  background-color: rgba(255, 255, 255, 0.01);
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  border-top: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  bottom: 0;
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  padding: var(--ace-primitive-spacing-normal);
  position: sticky;
  width: 100%;
  z-index: 2;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--general__cta-block {
    gap: var(--ace-primitive-spacing-normal);
  }
}
.ace-hero-item__content--general__cta-block ::slotted(div) {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--general__cta-block ::slotted(div) {
    gap: var(--ace-primitive-spacing-normal);
  }
}
.ace-hero-item__content--general__cta-block ace-button {
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--general__cta-block {
    backdrop-filter: unset;
    -webkit-backdrop-filter: unset;
    background-color: unset;
    border: 0;
    gap: var(--ace-primitive-spacing-normal);
    padding: 0;
    position: unset;
  }
}
.ace-hero-item__content--general__visual-block {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  order: 1;
  position: relative;
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--general__visual-block {
    order: 2;
    width: 66.66%;
  }
}
.ace-hero-item__content--general__controls-block {
  display: none;
  z-index: 2;
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--general__controls-block {
    display: flex;
    gap: var(--ace-primitive-spacing-normal);
    justify-content: flex-start;
    margin-top: var(--ace-primitive-spacing-x-loose);
    position: unset;
  }
}
.ace-hero-item__content--general__controls-block--mobile {
  display: flex;
  justify-content: space-between;
  padding: 0 var(--ace-primitive-spacing-normal);
  position: absolute;
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-hero-item__content--general__controls-block--mobile {
    padding: 0 var(--ace-primitive-spacing-normal);
  }
}
@media only screen and (min-width: 1025px) {
  .ace-hero-item__content--general__controls-block--mobile {
    display: none;
  }
}
.ace-hero-item__foreground-image {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
  z-index: 2;
}
.ace-hero-item__bg {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}
.ace-hero-item__bg--with-overlay::after {
  background-color: var(--ace-color-surface-glass--image);
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}